import React, { useState, useEffect } from 'react';

const StiAssessment = () => {
    const [quizStarted, setQuizStarted] = useState(false);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);

    useEffect(() => {
        document.body.className = 'gynecare-page';
        return () => { document.body.className = ''; };
    }, []);

    const questions = [
        {
            question: "Do you use protection (condoms) during sexual activity?",
            options: [
                { text: "Always", points: 0 },
                { text: "Sometimes", points: 15 },
                { text: "Never", points: 25 }
            ]
        },
        {
            question: "How many sexual partners have you had in the last 6 months?",
            options: [
                { text: "0 - 1 Partner", points: 0 },
                { text: "2 - 3 Partners", points: 15 },
                { text: "More than 3", points: 25 }
            ]
        },
        {
            question: "Are you experiencing any unusual symptoms (itching, discharge, or pain)?",
            options: [
                { text: "No symptoms", points: 0 },
                { text: "Minor irritation", points: 10 },
                { text: "Yes, definitely", points: 25 }
            ]
        },
        {
            question: "Do you discuss sexual health status with new partners?",
            options: [
                { text: "Yes, always", points: 0 },
                { text: "Sometimes", points: 10 },
                { text: "Never", points: 15 }
            ]
        }
    ];

    const handleAnswer = (points) => {
        setScore(prev => prev + points);
        if (currentQuestion + 1 < questions.length) {
            setCurrentQuestion(prev => prev + 1);
        } else {
            setShowResult(true);
        }
    };

    return (
        <main className="container" style={{ padding: '4rem 1rem' }}>
            
            {/* 🏁 STAGE 1: Welcome Screen */}
            {!quizStarted && !showResult && (
                <div className="card" style={{ maxWidth: '700px', margin: '0 auto', padding: '3rem', textAlign: 'center', borderRadius: '24px' }}>
                    <div className="card-icon" style={{ fontSize: '3.5rem', color: '#e91e63' }}>
                        <i className="fas fa-user-shield"></i>
                    </div>
                    <h2 style={{ margin: '1.5rem 0' }}>Confidential STI Assessment</h2>
                    <p style={{ color: '#666', marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Identify potential risks and learn more about your sexual health through our anonymous self-assessment tool.
                    </p>
                    <div style={{ textAlign: 'left', background: '#fff5f8', padding: '1.5rem', borderRadius: '15px', marginBottom: '2rem' }}>
                        <p style={{ margin: '5px 0' }}><i className="fas fa-lock" style={{ marginRight: '10px', color: '#e91e63' }}></i> 100% Anonymous - No data is saved.</p>
                        <p style={{ margin: '5px 0' }}><i className="fas fa-clock" style={{ marginRight: '10px', color: '#e91e63' }}></i> Takes only 1-2 minutes.</p>
                    </div>
                    <button className="btn btn-primary" style={{ width: '100%', padding: '1rem' }} onClick={() => setQuizStarted(true)}>
                        Take the Quiz Now
                    </button>
                </div>
            )}

            {/* 📝 STAGE 2: The Quiz Questions */}
            {quizStarted && !showResult && (
                <div className="card" style={{ maxWidth: '700px', margin: '0 auto', padding: '2.5rem', borderRadius: '24px' }}>
                    <div style={{ marginBottom: '1.5rem', color: '#e91e63', fontWeight: 'bold' }}>
                        Question {currentQuestion + 1} of {questions.length}
                    </div>
                    <h3 style={{ marginBottom: '2rem' }}>{questions[currentQuestion].question}</h3>
                    <div style={{ display: 'grid', gap: '12px' }}>
                        {questions[currentQuestion].options.map((opt, i) => (
                            <button key={i} className="btn btn-outline" onClick={() => handleAnswer(opt.points)} style={{ textAlign: 'left', padding: '1.2rem' }}>
                                {opt.text}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {/* 🏆 STAGE 3: Results & Articles Section */}
            {showResult && (
                <>
                    <div className="card" style={{ maxWidth: '700px', margin: '0 auto 4rem', padding: '3rem', textAlign: 'center', borderRadius: '24px' }}>
                        <h2 style={{ marginBottom: '1rem' }}>Your Results</h2>
                        <h1 style={{ fontSize: '4.5rem', fontWeight: '900', color: score > 35 ? '#f44336' : '#4caf50', margin: '10px 0' }}>
                            {score}%
                        </h1>
                        <p style={{ fontSize: '1.2rem', color: '#555' }}>Risk Level Detected</p>
                        <div style={{ padding: '1.5rem', background: score > 35 ? '#fff5f5' : '#f5fff7', borderRadius: '15px', margin: '2rem 0' }}>
                            <p style={{ margin: 0 }}>
                                {score > 35 
                                    ? "⚠️ Your responses suggest a potential risk. We recommend consulting a healthcare provider for professional testing." 
                                    : "✅ Your responses suggest a lower risk. Continue practicing safe habits and routine check-ups."}
                            </p>
                        </div>
                        <button className="btn btn-primary" onClick={() => window.location.reload()}>Retake Quiz</button>
                    </div>

                    {/* Articles - Quiz khatam hote hi niche dikhenge */}
                    <section>
                        <h2 style={{ textAlign: 'center', marginBottom: '3rem' }}>Information & Resources</h2>
                        <div className="specialty-cards">
                            <article className="card">
                                <div className="card-icon" style={{ color: '#2196f3' }}><i className="fas fa-info-circle"></i></div>
                                <h3>Symptoms to Watch</h3>
                                <p>Unusual discharge, pain during urination, or sores are common signs. Many STIs show no symptoms early on.</p>
                            </article>
                            <article className="card">
                                <div className="card-icon" style={{ color: '#4caf50' }}><i className="fas fa-vial"></i></div>
                                <h3>Testing Frequency</h3>
                                <p>Experts recommend testing every 6-12 months or after a new partner to maintain long-term safety.</p>
                            </article>
                            <article className="card">
                                <div className="card-icon" style={{ color: '#9c27b0' }}><i className="fas fa-shield-alt"></i></div>
                                <h3>Prevention First</h3>
                                <p>Correct condom use and vaccinations (like HPV) are the most effective ways to prevent transmission.</p>
                            </article>
                        </div>
                    </section>
                </>
            )}
        </main>
    );
};

export default StiAssessment;